import { styled } from '@mui/system'
import { TextField } from '../../../../Components/LazyComponents'
import { colors, fontSizes } from '../../../../Components/consts'

export const EmailInput = styled(TextField)(({ theme }) => ({
  minWidth: '25%',
  fontSize: fontSizes.small,
  [theme.breakpoints.between('md', 'lg')]: {
    minWidth: '35%',
  },
  [theme.breakpoints.down('md')]: {
    minWidth: '80%',
    marginBottom: theme.spacing(2),
  },
  '& .MuiInputBase-root': {
    backgroundColor: colors.gray.gray20,
    borderRadius: theme.spacing(4),
    '& .MuiInputBase-input': {
      color: colors.text,
      fontWeight: 500,
    },
  },
  '& .MuiInputLabel-root': {
    color: colors.text,
    fontWeight: 600,
    fontSize: fontSizes.small,
    '&.Mui-focused': {
      display: 'none !important',
    },
  },
}))
